import { lpad } from './stringUtils';

export const currencyFormat = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

export const formatarNit = (nit: string | number): string => {
  if (!nit) return '';

  nit = nit.toString();

  // Formato SAT: 110.15177.32-2
  var nitFormatado = nit.slice(-1);
  nitFormatado = nit.slice(-3, -1) + '-' + nitFormatado;
  nitFormatado = nit.slice(-8, -3) + '.' + nitFormatado;
  nitFormatado = nit.slice(-11, -8) + '.' + nitFormatado;

  return nitFormatado;
};

export const formatarCpf = (cpf) => {
  if (!cpf) return '';

  cpf = lpad(cpf.toString(), '0', 14);

  // Ex: 11122233300
  let cpfFormatado = cpf.slice(-2);
  cpfFormatado = cpf.slice(-5, -2) + '-' + cpfFormatado;
  cpfFormatado = cpf.slice(-8, -5) + '.' + cpfFormatado;
  cpfFormatado = cpf.slice(-11, -8) + '.' + cpfFormatado;

  return cpfFormatado;
};

export const formatarCep = (cep) => {
  if (!cep) return '';

  cep = cep.toString();

  // Ex: 60123123
  var cepFormatado = cep.slice(-3);
  cepFormatado = cep.slice(-6, -3) + '-' + cepFormatado;
  cepFormatado = cep.slice(-8, -6) + '.' + cepFormatado;

  return cepFormatado;
};

export const formatarCNPJ = (cnpj) => {
  cnpj = String(cnpj);
  return cnpj.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export const formatarCEI = (cei) => {
  cei = String(cei);
  return cei.replace(/^(\d{2})(\d{3})(\d{5})(\d{3})/, "$1.$2.$3/$4");
}

export const formatarNumeroFamiliar = (numeroFamiliar) => {
  if (!numeroFamiliar) return '';

  numeroFamiliar = lpad(numeroFamiliar.toString(), '0', 11);

  let numeroFamiliarFormatado = numeroFamiliar.slice(-2);
  numeroFamiliarFormatado = numeroFamiliar.slice(-11, -2) + '-' + numeroFamiliarFormatado;

  return numeroFamiliarFormatado;
};

export const obterMesAnoExtenso = (numeroCompetencia) => {
  let anoCompetencia;
  let mesCompetencia;

  if (!numeroCompetencia) {
    return
  }

  if (numeroCompetencia.toString().includes("-")) {
    anoCompetencia = numeroCompetencia.toString().substring(0,4);
    mesCompetencia = numeroCompetencia.toString().substring(5,8);
  } else {
    anoCompetencia = numeroCompetencia.toString().substring(0,4);
    mesCompetencia = numeroCompetencia.toString().substring(4,6);
  }

  const meses = [{
    mes: "01",
    mesExtenso: "JANEIRO",
    anoCompetencia
  },
  {
    mes: "02",
    mesExtenso: "FEVEREIRO",
    anoCompetencia
  },
  {
    mes: "03",
    mesExtenso: "MARÇO",
    anoCompetencia
  },
  {
    mes: "04",
    mesExtenso: "ABRIL",
    anoCompetencia
  },
  {
    mes: "05",
    mesExtenso: "MAIO",
    anoCompetencia
  },
  {
    mes: "06",
    mesExtenso: "JUNHO",
    anoCompetencia
  },
  {
    mes: "07",
    mesExtenso: "JULHO",
    anoCompetencia
  },
  {
    mes: "08",
    mesExtenso: "AGOSTO",
    anoCompetencia
  },
  {
    mes: "09",
    mesExtenso: "SETEMBRO",
    anoCompetencia
  },
  {
    mes: "10",
    mesExtenso: "OUTUBRO",
    anoCompetencia
  },
  {
    mes: "11",
    mesExtenso: "NOVEMBRO",
    anoCompetencia
  },
  {
    mes: "12",
    mesExtenso: "DEZEMBRO",
    anoCompetencia
  }];

  return meses.find((m) =>
    m.mes === mesCompetencia
  );
};

export const formatarCompetencia = (competencia:string) => {

  if (competencia) {
    const anoCompetencia = competencia.toString().substring(0,4);
    const mesCompetencia = competencia.toString().substring(5,7);

   return mesCompetencia + "/" + anoCompetencia;
  }

  return "";
};

//VERIFICAR A NECESSIDADE DE MANTER 2 TIPOS DE FORMATACAO PARA COMPETENCIA
export const formatarCompetenciaTipo2 = (competencia: string) => {
  const anoCompetencia = competencia.toString().substring(0,4);
  const mesCompetencia = competencia.toString().substring(4,6);

 return mesCompetencia + "/" + anoCompetencia;
};
